import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
// POST erpnext_v1/<lang>/sales-lead/create (form-urlencoded).
// erpFetcher's base URL already injects the active language segment.
export var submitFleetLead = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
    var _res$data;
    var body, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          body = new URLSearchParams();
          Object.entries(payload).forEach(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];
            if (value !== undefined && value !== null && value !== "") {
              body.append(key, String(value));
            }
          });
          _context.n = 1;
          return erpFetcher().post("sales-lead/create", body, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        case 1:
          res = _context.v;
          if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success) {
            _context.n = 2;
            break;
          }
          throw new Error("fleet-lead-submit-failed");
        case 2:
          return _context.a(2, {
            success: true
          });
      }
    }, _callee);
  }));
  return function submitFleetLead(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default submitFleetLead;